/* ZSportsTech — section-toc.js · Cricket IQ article
   Generates the Table of Contents from the article body's <h2> headings
   (id-slugs each), wires scroll-spy + smooth-scroll, and clones the list
   into the mobile "In this guide" disclosure. The TOC is NEVER authored —
   it is derived from {{ article.content }} so it always matches the body.
   Vanilla, namespaced, reduced-motion aware, accessible.
   Maps to → assets/section-toc.js in the Shopify theme.
   ─────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var body = document.getElementById('sc-iqrte');
  var list = document.getElementById('sc-iqtoc-list');
  if (!body || !list) return;

  var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
  if (!headings.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slugify(text) {
    return text.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  /* Build links — one per <h2>, id-slugged (deduped). */
  var used = {};
  var links = headings.map(function (h, i) {
    var base = slugify(h.textContent) || ('section-' + (i + 1));
    var id = base;
    var n = 2;
    while (used[id]) { id = base + '-' + n; n++; }
    used[id] = true;
    h.id = id;

    var a = document.createElement('a');
    a.className = 'sc-iqtoc__link';
    a.href = '#' + id;
    a.textContent = h.textContent;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + id);
    });
    list.appendChild(a);
    return a;
  });

  /* Mobile disclosure — clone the same links into the <details> list. */
  var mList = document.getElementById('sc-iqtoc-m-list');
  if (mList) {
    headings.forEach(function (h) {
      var a = document.createElement('a');
      a.className = 'sc-iqtoc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + h.id);
        var det = a.closest('details');
        if (det) det.open = false;
      });
      mList.appendChild(a);
    });
  }

  /* Scroll-spy — highlight the link whose section is currently in view. */
  var byId = {};
  links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });

  function setActive(id) {
    links.forEach(function (a) {
      a.classList.toggle('sc-iqtoc__link--active', a.getAttribute('href').slice(1) === id);
    });
  }

  if ('IntersectionObserver' in window) {
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        visible[en.target.id] = en.isIntersecting ? en.intersectionRatio : 0;
      });
      /* pick the heading nearest the top that is on screen */
      var best = null, bestTop = Infinity;
      headings.forEach(function (h) {
        var top = h.getBoundingClientRect().top;
        if (top <= 140 && top > -h.offsetHeight - 600 && top < bestTop) { bestTop = top; best = h.id; }
      });
      if (!best) {
        /* before the first heading scrolls under the nav → first link */
        best = headings[0].id;
      }
      setActive(best);
    }, { rootMargin: '-120px 0px -65% 0px', threshold: [0, 1] });
    headings.forEach(function (h) { io.observe(h); });
  }

  setActive(headings[0].id);
}());
